export class Policy {
    id?: number;
    applicationId?: number;
    version?: number;
    policyType?: number;
    policyWording?: string;
}